import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";

import splashBackground from "../../assets/images/signIn-splash-screen.svg";
import {
  colors,
  fontFamily,
  hvCenter,
  pxtorem,
} from "../../assets/styles/theme";
import { Box, Link, Typography, CircularProgress } from "@mui/material";

import { useGetAuthorization } from "../hooks/auth.hooks";
import { COPY_RIGHT_TEXT } from "../helpers/constants";

const HomeSignInSplashScreen = styled.div`
  height: calc(100% + 60px);
  margin-top: -60px;
  ${hvCenter};
  flex-direction: column;
  background: radial-gradient(at center, #fff 46.38%, #cdcdcd 100%);

  .splashBg {
    margin-top: -60px;
    width: 100%;
    max-width: 740px;
    height: 100%;
    max-height: 580px;

    background-image: url(${splashBackground});
    background-size: contain;
    background-repeat: no-repeat;
    .link-splash {
      margin: 46.5% 0 0 46%;
    }
  }
  .txt-copyright {
    font-family: ${fontFamily.karla};
    font-size: ${pxtorem(10)};
    color: ${colors.primaryDark};
    line-height: 11.69px;
    position: absolute;
    bottom: 20px;
  }
`;

const Home = () => {
  const navigate = useNavigate();

  const [callAuthenticate, setCallAuthenticate] = React.useState(false);

  const {
    data: authData,
    isFetching: isAuthDataLoading,
    refetch,
  } = useGetAuthorization(callAuthenticate);

  console.log("authData", authData);

  React.useEffect(() => {
    if (authData) {
      if (authData?.data) {
        setCallAuthenticate(false);
        window.open(authData?.data, "_self")
      } else {
        navigate("/error-page", {state : "Something went wrong. Please Try again later"});
      }
    }
    
  }, [authData, !isAuthDataLoading]);

  const handleSignIn = () => {
    setCallAuthenticate(true);
  };

  return (
    <>
      <HomeSignInSplashScreen>
        <Box className="splashBg">
          <div onClick={() => handleSignIn()}>
            <Link className="link-splash">Sign In {isAuthDataLoading && <CircularProgress  size="1rem"/>}</Link>
          </div>
          
        </Box>
        <Typography variant="body2" className="txt-copyright">
          {COPY_RIGHT_TEXT}
        </Typography>
      </HomeSignInSplashScreen>
    </>
  );
};

export default Home;
